import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD MEMBER DETAILS START *********************** */
export const memberDetailsAdd = (addData: any) => {
	const data = {
		CreateMemberToken: addData,
	};
	const url = `${API_URL}addMemberPhoneNumber`;
	return makeApiCall(url, data);
};
/** ***************** ADD MEMBER DETAILS END *********************** */

/** ***************** UPDATE MEMBER DETAILS START *********************** */
export const memberDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateMemberDetailsToken: updateData,
	};
	const url = `${API_URL}updateMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE MEMBER DETAILS END *********************** */

/** ***************** GET MEMBER LIST START *********************** */
export const memberListGet = (listData: any) => {
	const data = {
		GetMemberListToken: listData,
	};
	const url = `${API_URL}getMemberList`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER LIST END *********************** */

/** ***************** FETCH MEMBER DETAILS START *********************** */
export const memberDetailsFetch = (fetchData: any) => {
	const data = {
		FetchMemberToken: fetchData,
	};
	const url = `${API_URL}fetchMemberDetailsforApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBER DETAILS END *********************** */

/** ***************** DELETE MEMBER DETAILS START *********************** */
export const memberDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteMemberDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE MEMBER DETAILS END *********************** */

/** ***************** FETCH CO-APPLICANT HIGHMARK START *********************** */
export const coApplicantHighMarkDetailsFetch = (fetchData: any) => {
	const data = {
		FetchCoApplicantHighMarkToken: fetchData,
	};
	const url = `${API_URL}fetchCoApplicantHighMarkDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CO-APPLICANT HIGHMARK END *********************** */

/** ***************** CHECK HIGHMARK START *********************** */
export const checkHighmarkDetailsFetch = (fetchData: any, documentType: any) => {
	const data = {
		CheckMemberHighMarkToken: fetchData,
		documentType,
	};
	const url = `${API_URL}callHighMark`;
	return makeApiCall(url, data);
};
/** ***************** CHECK HIGHMARK END *********************** */

/** ***************** CHECK EQUIFAX START *********************** */
export const checkEquifaxDetailsFetch = (fetchData: any, documentType: any) => {
	const data = {
		checkEquifaxToken: fetchData,
		documentType,
	};
	const url = `${API_URL}uploadEquifaxDetailsWeb`;
	return makeApiCall(url, data);
};
/** ***************** CHECK EQUIFAX END *********************** */

/** ***************** CHECK CO-APPLICANT HIGHMARK START *********************** */
export const checkCoApplicantHighmarkDetailsFetch = (fetchData: any) => {
	const data = {
		CheckCoAppliantHighMarkToken: fetchData,
	};
	const url = `${API_URL}callCoApplicantHighMarkWeb`;
	return makeApiCall(url, data);
};
/** ***************** CHECK CO-APPLICANT HIGHMARK END *********************** */

/** ***************** UPDATE NO LOAN MEMBER START *********************** */
export const updateNoLoanMember = (fetchData: any, documentType: string) => {
	let API_NAME = '';
	if (documentType === 'updateNoLoanMemberWeb') {
		API_NAME = 'updateIsNoLoanMember';
	}
	if (documentType === 'updateTopupLoanMemberWeb') {
		API_NAME = 'updateTopupLoanNeeded';
	}
	const data = {
		updateNoLoanMemberToken: fetchData,
	};
	const url = `${API_URL}${API_NAME}`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE NO LOAN MEMBER END *********************** */

/** ***************** UPDATE MEMBER APPROVE STATUS START *********************** */
export const updateMemberIsApproveService = (fetchData: any) => {
	const data = {
		updateIsApproveMemberToken: fetchData,
	};
	const url = `${API_URL}updateMemberIsApprove`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE MEMBER APPROVE STATUS END *********************** */

/** ***************** VERIFY DOCUMENTS START *********************** */
export const verifyDocumentDetailsFetch = (fetchData: any, documentType: string) => {
	const data = {
		DocumentVerificationToken: fetchData,
	};
	let API_NAME = '';
	if (documentType === 'Aadhar') API_NAME = 'VerifyAadharKYCForWeb';
	if (documentType === 'AadharOTP') API_NAME = 'AadharOtpVerifyForWeb';
	if (documentType === 'PAN' || documentType === 'PanCard')
		API_NAME = 'VerifyPanDetailedKYCForWeb';
	if (documentType === 'PassPort') API_NAME = 'VerifyPanDetailedKYCForWeb';
	if (documentType === 'DrivingLicense') API_NAME = 'VerifyDrivingKYCForWeb';
	if (documentType === 'VoterID') API_NAME = 'VerifyVoterIDKYCForWeb';
	if (documentType === 'AadharOTPValidation') API_NAME = 'AadharOtpValidateVerifyForWeb';
	if (documentType === 'PENNYDROP') API_NAME = 'VerifyPennyDropKYCForWeb';

	const url = `${API_URL}${API_NAME}`;
	return makeApiCall(url, data);
};
/** ***************** VERIFY DOCUMENTS END *********************** */

/** ***************** FETCH PAYSPRINT LOG START *********************** */
export const PaySprintLogDetailsFetch = (fetchData: any) => {
	const data = {
		FetchPaySprintLogToken: fetchData,
	};
	const url = `${API_URL}fetchPaySprintLogDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PAYSPRINT LOG END *********************** */

/** ***************** FETCH MEMBER AUDIT LOG START *********************** */
export const MemberAuditDetailsFetch = (fetchData: any) => {
	const data = {
		MemberAuditFetchApproveToken: fetchData,
	};
	const url = `${API_URL}getMemberAuditAnswersForApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBER AUDIT LOG END *********************** */

/** ***************** CHECK MEMBER TOPUP LOAN START *********************** */
export const checkTopupLoanMember = (fetchData: any) => {
	const data = {
		checkMemberTopupToken: fetchData,
	};
	const url = `${API_URL}checkMemberTopupWeb`;
	return makeApiCall(url, data);
};
/** ***************** CHECK MEMBER TOPUP LOAN END *********************** */

/** ***************** FETCH MEMBER VERIFY LOG START *********************** */
export const MemberVerifyDetailsFetch = (fetchData: any) => {
	const data = {
		MemberVerifyFetchApproveToken: fetchData,
	};
	const url = `${API_URL}getMemberVerifyDetailsForApprove`;
	return makeApiCall(url, data);
};
/** ***************** FETCH MEMBER VERIFY LOG END *********************** */

/** ***************** UPDATE MEMBER VERIFY LOG START *********************** */
export const MemberVerifyDetailsUpdate = (fetchData: any) => {
	const data = {
		MemberVerifyUpdateApproveToken: fetchData,
	};
	const url = `${API_URL}updateMemberVerifyDetailsForApprove`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE MEMBER VERIFY LOG END *********************** */

/** ***************** UPDATE MEMBER KYC DETAILS START *********************** */
export const MemberKYCDetailsUpdate = (fetchData: any) => {
	const data = {
		MemberKYCUpdateToken: fetchData,
	};
	const url = `${API_URL}updateMemberKYCDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE MEMBER KYC DETAILS END *********************** */

/** ***************** UPDATE MEMBER TRANSFER DETAILS START *********************** */
export const MemberTransferDetailsUpdate = (fetchData: any) => {
	const data = {
		MemberTransferUpdateToken: fetchData,
	};
	const url = `${API_URL}updateMemberTransferDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE MEMBER TRANSFER DETAILS END *********************** */

/** ***************** ADD MEMBER OTHER DETAILS START *********************** */
export const memberOtherDetailsAdd = (addData: any) => {
	const data = {
		UpdateMemberOtherDetailsToken: addData,
	};
	const url = `${API_URL}updateMemberOtherDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD MEMBER OTHER DETAILS END *********************** */

/** ***************** ADD MEMBER BUSINESS DETAILS START *********************** */
export const memberBusinessDetailsAdd = (addData: any) => {
	const data = {
		AddMemberBusinessDetailsToken: addData,
	};
	const url = `${API_URL}updateMemberBusinessDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD MEMBER BUSINESS DETAILS END *********************** */
